import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Authenticationservice } from 'src/app/core/authentication/authenticationService';

@Component({
  selector: 'app-subcribe',
  templateUrl: './subcribe.component.html',
  styleUrls: ['./subcribe.component.scss']
})
export class SubcribeComponent implements OnInit {
  ViewBag:any=
  {
    Message:'',
    isSuccess:null
  };
  loading:boolean=false;
  token:any;
  username:any;
  password:any;
  confirmpassword:any;
  constructor(private route:ActivatedRoute,private authenticationservice:Authenticationservice)
  {
  
  }
    ngOnInit(): void {
      var data = this.route.snapshot.data['data'];
      if(data){
        this.token=data.token;
        this.username=data.Username;
        if (this.username) {
          (document.getElementById("username")  as HTMLInputElement).value = this.username;
        }
        this.ViewBag.Message=data.Message;
      }
  }
  Subscribe()
  {
    if(this.ValidatePassword())
    {
      this.authenticationservice.SubscribeSave(this.username,this.password,this.token).subscribe((res)=>
      {
        if(res){
          this.loading=false;
          (document.getElementById('page')as HTMLElement).style.opacity = '1';
          if(res.isSuccess)
          {
            this.ViewBag.Message=res.message;
            this.ViewBag.isSuccess=res.isSuccess;
            this.clear();
          }
          else
          {
            this.ViewBag.Message=res.message;
          }
        }
      });
    }
  }
  
  clear(){
    (document.getElementById("username")  as HTMLInputElement).value = '';
    (document.getElementById("password")  as HTMLInputElement).value = '';
    (document.getElementById("confirmpassword")  as HTMLInputElement).value ='';
  }
  ValidatePassword() {

    var username = (document.getElementById("username")  as HTMLInputElement).value;
    var password = (document.getElementById("password")as HTMLInputElement).value;	
    var confirmpassword = (document.getElementById("confirmpassword")as HTMLInputElement).value;
    
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[0-9])(^.{8,15})");

     var reg =  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;///^([A-Za-z0-9_\-\.])+\@@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    
    if (username == "") {
        window.alert("Please Enter Username");
        return false;
    }
    
    if (password == "") {
        window.alert("Please Enter Password");
        return false;
    }
    
    if (reg.test(username) == false) {
        alert('Please Enter Valid Username');
        return false;
    }
    
    if (!strongRegex.test(password)) {
        window.alert("Please Enter Valid Password");
        (document.getElementById("error")as HTMLInputElement).hidden = false;
        return false;
    }
    
    if (confirmpassword == "") {
        window.alert("Confirm Password cannot be empty");
        (document.getElementById("confirmpassworderror")as HTMLInputElement).hidden = false;
        return false;
    }
    
    if (!strongRegex.test(confirmpassword)) {
        window.alert("Invalid Confirm Password");
        (document.getElementById("confirmpassworderror")as HTMLInputElement).hidden = false;
        return false;
    }
    
    if (confirmpassword != password) {
        window.alert("Confirm Passwords do not match");
        (document.getElementById("confirmpassworderror")as HTMLInputElement).hidden = false;
        return false;
    }
    
    (document.getElementById('page')as HTMLElement).style.opacity = '0.5';
    this.loading=true;
    this.password=password;
    this.username=username;
    this.confirmpassword=confirmpassword;
    return true;
    
    }

}
